var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRectangle = function SvgIconRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F8",
    fillRule: "nonzero",
    d: "M0 0h48v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7971",
    d: "M47 1H1v30h46zM0 0v32h48V0z"
  }))));
};
export { SvgIconRectangle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjRjlGOUY4IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHdpZHRoPSI0OCIgaGVpZ2h0PSIzMiIvPjxwYXRoIGQ9Ik00NywxIEwxLDEgTDEsMzEgTDQ3LDMxIEw0NywxIFogTTAsMCBMMCwzMiBMNDgsMzIgTDQ4LDAgTDAsMCBaIiBmaWxsPSIjN0Q3OTcxIi8+PC9nPjwvc3ZnPg==";